import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { 
  FaWhatsapp, 
  FaHeart, 
  FaRegHeart, 
  FaStar, 
  FaHome, 
  FaUser, 
  FaBox, 
  FaMapMarkerAlt, 
  FaCreditCard, 
  FaQuestionCircle, 
  FaCog,
  FaFish,
  FaTruck,
  FaShoppingBag,
  FaCheckCircle,
  FaLeaf,
  FaPhone,
  FaArrowRight,
  FaFilter,
  FaSearch,
  FaTimes,
  FaWater,
  FaTree,
  FaSun,
  FaDollarSign,
  FaGold
} from 'react-icons/fa';
import { GiFishbone, GiGrowth, GiFishCorpse, GiGoldBar } from 'react-icons/gi';
import { MdLocalShipping, MdOutlineCleanHands } from 'react-icons/md';

// Fish Products Data - 30+ Fishes
const fishProducts = [
  // Growing Fishes (Fast Growth)
//   { id: 1, name: 'Rohu Fish', category: 'Growing', price: 350, oldPrice: 450, weight: '500g', description: 'Fast-growing freshwater fish, ideal for pond culture', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmI7RojIPtUTDqi4NILf81Zg9WZh2Yz-4x9Q&s', rating: 4.8, reviews: 234, badge: 'Best Seller', growth: 'Fast', type: 'Growing' },
//   { id: 2, name: 'Catla Fish', category: 'Growing', price: 420, oldPrice: 550, weight: '500g', description: 'Quick growth rate, reaches market size in 6-8 months', image: 'https://i.pinimg.com/564x/6b/5e/70/6b5e70f11eca49518cb78d6a55f87704.jpg', rating: 4.7, reviews: 189, badge: 'Popular', growth: 'Fast', type: 'Growing' },
//   { id: 3, name: 'Mrigal Fish', category: 'Growing', price: 380, oldPrice: 480, weight: '500g', description: 'Bottom feeder, grows rapidly in composite culture', image: 'https://aquariumwhisperer.com/wp-content/uploads/2023/09/Mrigal-Carp.jpg', rating: 4.6, reviews: 156, badge: null, growth: 'Fast', type: 'Growing' },
//   { id: 4, name: 'Grass Carp', category: 'Growing', price: 450, oldPrice: 580, weight: '500g', description: 'Fast-growing herbivorous fish, excellent weed control', image: 'https://cdn11.bigcommerce.com/s-m39bqdjce8/images/stencil/1280x1280/uploaded_images/grass-carp.jpg?t=1700625733', rating: 4.9, reviews: 278, badge: 'New', growth: 'Very Fast', type: 'Growing' },
//   { id: 5, name: 'Silver Carp', category: 'Growing', price: 320, oldPrice: 420, weight: '500g', description: 'Plankton feeder, rapid growth rate', image: 'https://static.vecteezy.com/system/resources/thumbnails/075/647/839/small/a-large-fish-swimming-in-the-water-photo.jpg', rating: 4.5, reviews: 145, badge: null, growth: 'Fast', type: 'Growing' },
//   { id: 6, name: 'Common Carp', category: 'Growing', price: 280, oldPrice: 380, weight: '500g', description: 'Hardy fish, adapts well to various conditions', image: 'https://cdn.prod.website-files.com/67249b8971d5d92521828be6/67bf0888e4a0315123418060_67b0693452e9c6a7cf2482b4_Common%2520Carp.webp', rating: 4.4, reviews: 198, badge: null, growth: 'Moderate', type: 'Growing' },
//   { id: 7, name: 'Bighead Carp', category: 'Growing', price: 390, oldPrice: 490, weight: '500g', description: 'Filter feeder, grows to large size quickly', image: 'https://a-z-animals.com/media/2022/09/bighead-carp-2.jpg', rating: 4.6, reviews: 123, badge: null, growth: 'Fast', type: 'Growing' },
//   { id: 8, name: 'Black Carp', category: 'Growing', price: 480, oldPrice: 620, weight: '500g', description: 'Mollusk feeder, excellent for snail control', image: 'https://tr-2.ru/files/styles/f/public/fotofish/amur_chernyy.jpg?itok=7fj_ej1N', rating: 4.7, reviews: 167, badge: 'Premium', growth: 'Fast', type: 'Growing' },
  
  // Pond Fishes
  { id: 9, name: 'Koi Fish', category: 'Pond', price: 850, oldPrice: 1200, weight: '300g', description: 'Beautiful ornamental fish for garden ponds', image: 'https://atlantiswatergardens.com/wp-content/uploads/2025/01/Multiple-koi-fish-of-all-different-color-variations-swim-around-each-other.jpeg', rating: 4.9, reviews: 567, badge: 'Best Seller', type: 'Pond' },
  { id: 10, name: 'Goldfish', category: 'Pond', price: 180, oldPrice: 250, weight: '100g', description: 'Classic pond fish, hardy and colorful', image: 'https://www.thesprucepets.com/thmb/VTMd2H_oaAWkZ6GD5G4tHVKHJYI=/2121x0/filters:no_upscale():strip_icc()/GettyImages-1370690855-691460005dd7426d9d716ed9c2b6ad8f.jpg', rating: 4.7, reviews: 892, badge: 'Popular', type: 'Pond' },
  { id: 11, name: 'Mollies', category: 'Pond', price: 120, oldPrice: 180, weight: '50g', description: 'Livebearers, great for small ponds', image: 'https://cdn.shopify.com/s/files/1/0311/3149/files/yellow_juvenile_molly_fish.jpg?v=1639601653', rating: 4.5, reviews: 234, badge: null, type: 'Pond' },
  { id: 12, name: 'Platies', category: 'Pond', price: 100, oldPrice: 150, weight: '50g', description: 'Colorful and peaceful pond fish', image: 'https://img.lb.wbmdstatic.com/vim/live/webmd/consumer_assets/site_images/article_thumbnails/SEEDs/1800x1200-what-to-know-about-platies-seed.jpg', rating: 4.6, reviews: 189, badge: null, type: 'Pond' },
  { id: 13, name: 'Swordtails', category: 'Pond', price: 140, oldPrice: 200, weight: '50g', description: 'Distinctive tail shape, active swimmers', image: 'https://www.thesprucepets.com/thmb/-cx9GdW7D-Wsp2i0W60dOwChz_w=/5268x0/filters:no_upscale():strip_icc()/swordtail-fish-species-profile-5078361-01-467f7fbdfedb4e458ad3204b15f23534.jpg', rating: 4.4, reviews: 156, badge: null, type: 'Pond' },
  { id: 14, name: 'Guppies', category: 'Pond', price: 80, oldPrice: 120, weight: '30g', description: 'Small, colorful, and prolific breeders', image: 'https://cdn.britannica.com/02/117202-050-62267C8B/Guppy.jpg', rating: 4.8, reviews: 734, badge: 'Popular', type: 'Pond' },
  { id: 15, name: 'Angelfish', category: 'Pond', price: 450, oldPrice: 650, weight: '150g', description: 'Elegant triangular shape, peaceful', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLvB_-RKIvxltcD-nNEz5kZ7Mxn-HnnLSk3A&s', rating: 4.7, reviews: 345, badge: null, type: 'Pond' },
  { id: 16, name: 'Discus', category: 'Pond', price: 1200, oldPrice: 1800, weight: '200g', description: 'Premium ornamental fish, stunning colors', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPIk_wknA41US08HGqWd2WKxblRsQwsNkkcg&s', rating: 4.9, reviews: 456, badge: 'Premium', type: 'Pond' },
  { id: 17, name: 'Oscar Fish', category: 'Pond', price: 550, oldPrice: 750, weight: '250g', description: 'Intelligent cichlid with personality', image: 'https://www.fishkeepingworld.com/wp-content/uploads/2019/01/Pair-of-Oscar-Fish.jpg', rating: 4.6, reviews: 278, badge: null, type: 'Pond' },
  { id: 18, name: 'Flowerhorn', category: 'Pond', price: 1500, oldPrice: 2200, weight: '300g', description: 'Unique head bump, vibrant colors', image: 'https://a-z-animals.com/media/2021/10/Flowerhorn-blue.jpg', rating: 4.8, reviews: 189, badge: 'Best Seller', type: 'Pond' },
  
  // Golden Fishes
  { id: 19, name: 'Golden Koi', category: 'Golden', price: 2500, oldPrice: 3500, weight: '400g', description: 'Rare golden variety, symbol of prosperity', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_DUMEF_bzxm87jZQ05oEVuFOS0eBl5uJA1w&s', rating: 4.9, reviews: 234, badge: 'Luxury', type: 'Golden' },
  { id: 20, name: 'Golden Oranda', category: 'Golden', price: 1800, oldPrice: 2500, weight: '250g', description: 'Goldfish with distinctive head growth', image: 'https://upload.wikimedia.org/wikipedia/commons/6/6b/Orange_Oranda.jpg', rating: 4.8, reviews: 167, badge: 'Premium', type: 'Golden' },
  { id: 21, name: 'Golden Ramirezi', category: 'Golden', price: 900, oldPrice: 1300, weight: '100g', description: 'Dwarf cichlid with golden shimmer', image: 'https://www.cloningaquapets.com/cdn/shop/files/Golden_balloon_Ram.png?v=1728051061&width=1214', rating: 4.7, reviews: 145, badge: null, type: 'Golden' },
  { id: 22, name: 'Golden Wonder Killifish', category: 'Golden', price: 350, oldPrice: 500, weight: '80g', description: 'Striking golden coloration, top dweller', image: 'https://shrimpybusiness.com/cdn/shop/files/GoldenWonderKillifish.jpg?v=1725930203&width=1920', rating: 4.6, reviews: 98, badge: null, type: 'Golden' },
  { id: 23, name: 'Golden Gourami', category: 'Golden', price: 280, oldPrice: 400, weight: '120g', description: 'Peaceful labyrinth fish, golden hue', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTat48jhXWmqd-L2OM6LS_-K_glnBkJXZqEiw&s', rating: 4.5, reviews: 234, badge: null, type: 'Golden' },
  { id: 24, name: 'Golden Barb', category: 'Golden', price: 150, oldPrice: 220, weight: '50g', description: 'Schooling fish with metallic sheen', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReKpYJAhXtQt1vduwb8txn8_EiyUXb66lDUg&s', rating: 4.7, reviews: 189, badge: null, type: 'Golden' },
  { id: 25, name: 'Golden Tetra', category: 'Golden', price: 120, oldPrice: 180, weight: '30g', description: 'Small shimmering fish for community tanks', image: 'https://static.vecteezy.com/system/resources/previews/072/852/649/large_2x/golden-tetra-fish-swimming-gracefully-in-a-lush-aquarium-habitat-free-photo.jpg', rating: 4.6, reviews: 278, badge: null, type: 'Golden' },
  { id: 26, name: 'Golden Severum', category: 'Golden', price: 750, oldPrice: 1000, weight: '200g', description: 'Large cichlid with golden body', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTm0SAd8vHKLkhL2cundeQ-r6A4kdZRfyRsfg&s', rating: 4.7, reviews: 134, badge: null, type: 'Golden' },
  { id: 27, name: 'Golden Pleco', category: 'Golden', price: 850, oldPrice: 1200, weight: '150g', description: 'Algae eater with golden spots', image: 'https://www.cloningaquapets.com/cdn/shop/files/AlgaeEaterBristleNoseGoldenPleco_2Inches_1.png?v=1725431536&width=1214', rating: 4.8, reviews: 212, badge: null, type: 'Golden' },
  { id: 28, name: 'Golden Arowana', category: 'Golden', price: 15000, oldPrice: 20000, weight: '500g', description: 'Premium golden dragon fish, rare', image: 'https://buyarowanafish.com/wp-content/uploads/2017/01/Golden-Arowana-Fish.jpg', rating: 4.9, reviews: 89, badge: 'Rare', type: 'Golden' },
  { id: 29, name: 'Golden Zebra Danio', category: 'Golden', price: 90, oldPrice: 130, weight: '20g', description: 'Active schooling fish, golden stripes', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDkZCHUY_ySe-wQH50CcZTqHuh-P_maaM03A&s', rating: 4.7, reviews: 345, badge: null, type: 'Golden' },
  { id: 30, name: 'Golden Rainbowfish', category: 'Golden', price: 320, oldPrice: 450, weight: '80g', description: 'Vibrant colors, peaceful community fish', image: 'https://www.newlands.ie/cdn/shop/files/YellowRainbowFish_1200x923.jpg?v=1763056362', rating: 4.8, reviews: 178, badge: null, type: 'Golden' },
  { id: 31, name: 'Golden Siamese Fighter', category: 'Golden', price: 280, oldPrice: 400, weight: '40g', description: 'Majestic golden betta fish', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAXQMmK-Gsk0KhuU78Ky-tPoxsU--H7lVgHA&s', rating: 4.9, reviews: 567, badge: 'Popular', type: 'Golden' },
  { id: 32, name: 'Golden Algae Eater', category: 'Golden', price: 180, oldPrice: 250, weight: '60g', description: 'Natural algae controller with golden color', image: 'https://vijayaquatics.com/wp-content/uploads/2025/01/WhatsApp-Image-2025-01-03-at-5.24.36-PM-1.jpeg', rating: 4.5, reviews: 234, badge: null, type: 'Golden' }
];

const FishPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [activeTab, setActiveTab] = useState('home');
  const [showSheet, setShowSheet] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [priceRange, setPriceRange] = useState('all');
  const [sortBy, setSortBy] = useState('default');

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const categories = ['All', 'Growing', 'Pond', 'Golden'];

  // Memoize filtered products to prevent unnecessary re-renders
  const filteredProducts = useMemo(() => {
    return fishProducts.filter(product => {
      const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
      const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            product.description.toLowerCase().includes(searchTerm.toLowerCase());
      let matchesPrice = true;
      if (priceRange === 'under500') matchesPrice = product.price < 500;
      else if (priceRange === '500to1000') matchesPrice = product.price >= 500 && product.price <= 1000;
      else if (priceRange === '1000to2000') matchesPrice = product.price >= 1000 && product.price <= 2000;
      else if (priceRange === 'above2000') matchesPrice = product.price > 2000;
      
      return matchesCategory && matchesSearch && matchesPrice;
    });
  }, [selectedCategory, searchTerm, priceRange]);

  // Memoize sorted products
  const sortedProducts = useMemo(() => {
    return [...filteredProducts].sort((a, b) => {
      if (sortBy === 'priceLow') return a.price - b.price;
      if (sortBy === 'priceHigh') return b.price - a.price;
      if (sortBy === 'rating') return b.rating - a.rating;
      return 0;
    });
  }, [filteredProducts, sortBy]);

  const formatPrice = (price) => `₹${price.toLocaleString('en-IN')}`;

  const toggleWishlist = useCallback((productId) => {
    setWishlist(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  }, []);

  const handleWhatsAppEnquiry = useCallback((product) => {
    const message = `Hi, I'm interested in ${product.name} (${product.weight}). Price: ${formatPrice(product.price)}. Please share more details.`;
    const whatsappUrl = `https://wa.me/918072621187?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  }, []);

  const openProductSheet = (product) => {
    if (isMobile) {
      setSelectedProduct(product);
      setShowSheet(true);
      document.body.style.overflow = 'hidden';
    }
  };

  const closeSheet = () => {
    setShowSheet(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto';
  };

  // Handle search input change - prevents re-renders from breaking focus
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Product Card Component - memoized to prevent unnecessary re-renders
  const ProductCard = React.memo(({ product }) => (
    <div
      className={`bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 ${
        isMobile ? 'active:scale-[0.98] cursor-pointer' : 'hover:-translate-y-1'
      }`}
      onClick={() => isMobile && openProductSheet(product)}
    >
      {product.badge && (
        <span className={`absolute z-10 mt-3 ml-3 px-3 py-1 rounded-full text-xs font-bold text-white flex items-center gap-1 ${
          product.badge === 'Best Seller' ? 'bg-orange-500' :
          product.badge === 'Premium' ? 'bg-purple-500' :
          product.badge === 'Luxury' ? 'bg-amber-500' :
          product.badge === 'Rare' ? 'bg-red-500' :
          product.badge === 'Popular' ? 'bg-blue-500' : 'bg-green-500'
        }`}>
          {product.badge === 'Best Seller' && <FaStar className="text-xs" />}
          {product.badge === 'Premium' && <FaDollarSign className="text-xs" />}
          {product.badge === 'Luxury' && <FaDollarSign className="text-xs" />}
          {product.badge}
        </span>
      )}
      
      <div className="relative w-full pt-[75%] overflow-hidden bg-gradient-to-br from-blue-50 to-cyan-50">
        <img 
          src={product.image} 
          alt={product.name}
          className="absolute top-0 left-0 w-full h-full object-cover object-center transition-transform duration-300 hover:scale-105"
          loading="lazy"
        />
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleWishlist(product.id);
          }}
          className="absolute top-3 right-3 w-10 h-10 bg-white/90 backdrop-blur rounded-full flex items-center justify-center shadow-md hover:scale-110 transition z-10"
        >
          {wishlist.includes(product.id) ? (
            <FaHeart className="text-red-500 text-xl" />
          ) : (
            <FaRegHeart className="text-gray-600 text-xl" />
          )}
        </button>
        {product.type === 'Golden' && (
          <div className="absolute bottom-2 left-2 bg-amber-500/80 backdrop-blur rounded-full px-2 py-0.5 text-[10px] font-bold text-white flex items-center gap-1">
            <FaDollarSign className="text-xs" /> GOLDEN
          </div>
        )}
        {product.type === 'Growing' && (
          <div className="absolute bottom-2 left-2 bg-green-500/80 backdrop-blur rounded-full px-2 py-0.5 text-[10px] font-bold text-white flex items-center gap-1">
            <GiGrowth className="text-xs" /> FAST GROWTH
          </div>
        )}
        {product.type === 'Pond' && (
          <div className="absolute bottom-2 left-2 bg-blue-500/80 backdrop-blur rounded-full px-2 py-0.5 text-[10px] font-bold text-white flex items-center gap-1">
            <FaWater className="text-xs" /> POND FISH
          </div>
        )}
      </div>
      
      <div className="p-4">
        <div className="flex justify-between items-start mb-1">
          <h3 className="font-bold text-gray-800 text-lg line-clamp-1 flex items-center gap-1">
            <FaFish className="text-green-600 text-sm" />
            {product.name}
          </h3>
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full whitespace-nowrap ml-2">{product.weight}</span>
        </div>
        
        <div className="flex items-center gap-1 mb-2">
          <FaStar className="text-yellow-500 text-sm" />
          <span className="text-sm font-medium text-gray-700">{product.rating}</span>
          <span className="text-xs text-gray-400">({product.reviews} reviews)</span>
        </div>
        
        <p className="text-gray-500 text-sm mb-3 line-clamp-2">{product.description}</p>
        
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <span className="text-xl font-bold text-green-700">{formatPrice(product.price)}</span>
          <span className="text-sm text-gray-400 line-through">{formatPrice(product.oldPrice)}</span>
          <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">
            {Math.round(((product.oldPrice - product.price) / product.oldPrice) * 100)}% OFF
          </span>
        </div>
        
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleWhatsAppEnquiry(product);
          }}
          className="w-full bg-green-500 text-white py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 hover:bg-green-600 transition"
        >
          <FaWhatsapp className="text-white text-lg" />
          Enquire Now
        </button>
      </div>
    </div>
  ));

  // Mobile Search Component - stable to prevent focus loss
  const MobileSearchBar = () => (
    <div className="px-4 py-3 bg-white border-b border-gray-100">
      <div className="relative">
        <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
        <input
          type="text"
          placeholder="Search fish..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="w-full pl-10 pr-10 py-2.5 bg-gray-100 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        {searchTerm && (
          <button 
            onClick={() => setSearchTerm('')} 
            className="absolute right-3 top-1/2 -translate-y-1/2"
            type="button"
          >
            <FaTimes className="text-gray-400 text-sm" />
          </button>
        )}
      </div>
    </div>
  );

  // Desktop Search Component
  const DesktopSearchBar = () => (
    <div className="relative">
      <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
      <input 
        type="text" 
        placeholder="Search fish..." 
        value={searchTerm} 
        onChange={handleSearchChange}
        className="pl-10 pr-4 py-2 border rounded-lg w-64 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
      />
    </div>
  );

  // Mobile View
  const MobileView = () => (
    <div className="max-w-md mx-auto bg-gray-50 min-h-screen relative shadow-xl">
      {/* Header */}
      <div className="sticky top-0 z-20 bg-white px-4 py-3 shadow-sm flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FaFish className="text-blue-500 text-2xl" />
          <h1 className="text-xl font-bold text-gray-800">Our Fish Products</h1>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setShowFilters(!showFilters)} className="relative">
            <FaFilter className="text-gray-600 text-xl" />
            {selectedCategory !== 'All' && (
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full" />
            )}
          </button>
          <button onClick={() => setActiveTab('wishlist')} className="relative">
            <FaHeart className="text-gray-600 text-xl" />
            {wishlist.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center">
                {wishlist.length}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Search Bar - Stable component */}
      {MobileSearchBar()}

      {/* Filters Panel */}
      {showFilters && (
        <div className="fixed inset-0 bg-black/50 z-30" onClick={() => setShowFilters(false)}>
          <div className="absolute bottom-12 left-0 right-0 bg-white rounded-t-3xl p-5 animate-slide-up" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-bold text-lg">Filters</h3>
              <button onClick={() => setShowFilters(false)}><FaTimes /></button>
            </div>
            
            <div className="mb-4">
              <h4 className="font-medium mb-2">Category</h4>
              <div className="flex gap-2 flex-wrap">
                {categories.map(cat => (
                  <button
                    key={cat}
                    onClick={() => setSelectedCategory(cat)}
                    className={`px-4 py-2 rounded-full text-sm ${
                      selectedCategory === cat ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>
            
            <div className="mb-4">
              <h4 className="font-medium mb-2">Price Range</h4>
              <div className="flex gap-2 flex-wrap">
                {['all', 'under500', '500to1000', '1000to2000', 'above2000'].map(range => (
                  <button
                    key={range}
                    onClick={() => setPriceRange(range)}
                    className={`px-4 py-2 rounded-full text-sm ${
                      priceRange === range ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    {range === 'all' ? 'All' : 
                     range === 'under500' ? 'Under ₹500' :
                     range === '500to1000' ? '₹500 - ₹1000' :
                     range === '1000to2000' ? '₹1000 - ₹2000' : 'Above ₹2000'}
                  </button>
                ))}
              </div>
            </div>
            
            <div className="mb-4">
              <h4 className="font-medium mb-2">Sort By</h4>
              <div className="flex gap-2 flex-wrap">
                {['default', 'priceLow', 'priceHigh', 'rating'].map(sort => (
                  <button
                    key={sort}
                    onClick={() => setSortBy(sort)}
                    className={`px-4 py-2 rounded-full text-sm ${
                      sortBy === sort ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    {sort === 'default' ? 'Default' :
                     sort === 'priceLow' ? 'Price: Low to High' :
                     sort === 'priceHigh' ? 'Price: High to Low' : 'Top Rated'}
                  </button>
                ))}
              </div>
            </div>
            
            <button onClick={() => setShowFilters(false)} className="w-full bg-green-600 text-white py-3 rounded-full font-semibold">
              Apply Filters
            </button>
          </div>
        </div>
      )}

      {/* Stats */}
      <div className="px-4 py-3 bg-white border-b border-gray-100">
        <p className="text-sm text-gray-500">{sortedProducts.length} fish found</p>
      </div>

      {/* Products Grid */}
      <div className="px-4 py-4 pb-24 space-y-4">
        {sortedProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-40" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div className="flex justify-around py-2">
          <button onClick={() => setActiveTab('home')} className={`flex flex-col items-center py-1 px-5 rounded-full transition ${activeTab === 'home' ? 'text-green-600' : 'text-gray-400'}`}>
            <FaHome className="text-2xl" />
            <span className="text-xs mt-0.5 font-medium">Home</span>
          </button>
          <button onClick={() => setActiveTab('wishlist')} className={`flex flex-col items-center py-1 px-5 rounded-full transition relative ${activeTab === 'wishlist' ? 'text-green-600' : 'text-gray-400'}`}>
            <FaHeart className="text-2xl" />
            <span className="text-xs mt-0.5 font-medium">Wishlist</span>
            {wishlist.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                {wishlist.length}
              </span>
            )}
          </button>
          {/* <button onClick={() => setActiveTab('profile')} className={`flex flex-col items-center py-1 px-5 rounded-full transition ${activeTab === 'profile' ? 'text-green-600' : 'text-gray-400'}`}>
            <FaUser className="text-2xl" />
            <span className="text-xs mt-0.5 font-medium">Profile</span>
          </button> */}
        </div>
      </div>

      {/* WhatsApp Button */}
      <a href="https://wa.me/918072621187?text=Hi%2C%20I'm%20interested%20in%20your%20fish" className="fixed bottom-20 right-4 bg-green-500 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg z-40" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp className="text-2xl" />
      </a>

      {/* Product Sheet */}
      {showSheet && selectedProduct && (
        <>
          <div className="fixed inset-0 bg-black/50 z-50" onClick={closeSheet} />
          <div className="fixed bottom-10 left-0 right-0 bg-white rounded-t-3xl z-50 transition-transform" style={{ maxWidth: '500px', margin: '0 auto' }}>
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mt-3 mb-4" />
            <div className="relative w-full h-64 overflow-hidden bg-gray-100">
              <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-full object-contain" />
            </div>
            <div className="p-5 pb-8">
              <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                <FaFish className="text-green-600" /> {selectedProduct.name}
              </h2>
              <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-full inline-block mt-1">{selectedProduct.weight}</span>
              <div className="flex items-center gap-2 mt-3">
                <span className="text-2xl font-bold text-green-700">{formatPrice(selectedProduct.price)}</span>
                <span className="text-sm text-gray-400 line-through">{formatPrice(selectedProduct.oldPrice)}</span>
              </div>
              <p className="text-gray-600 text-sm mt-3">{selectedProduct.description}</p>
              <div className="flex gap-3 mt-6">
                <button onClick={() => handleWhatsAppEnquiry(selectedProduct)} className="flex-1 bg-green-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2">
                  <FaWhatsapp /> Enquire Now
                </button>
                <button onClick={() => toggleWishlist(selectedProduct.id)} className={`px-5 py-3 rounded-xl border font-semibold ${wishlist.includes(selectedProduct.id) ? 'border-red-300 bg-red-50 text-red-500' : 'border-gray-300 text-gray-600'}`}>
                  {wishlist.includes(selectedProduct.id) ? <FaHeart /> : <FaRegHeart />}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );

  // Desktop View
  const DesktopView = () => (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FaFish className="text-green-600 text-3xl" />
            <span className="text-2xl font-bold text-green-700">Our Fish Products</span>
          </div>
          <div className="flex items-center gap-6">
            <button onClick={() => setActiveTab('home')} className={`font-medium transition ${activeTab === 'home' ? 'text-green-600 border-b-2 border-green-600 pb-1' : 'text-gray-600 hover:text-green-600'}`}>Home</button>
            <button onClick={() => setActiveTab('wishlist')} className={`font-medium transition flex items-center gap-1 ${activeTab === 'wishlist' ? 'text-green-600 border-b-2 border-green-600 pb-1' : 'text-gray-600 hover:text-green-600'}`}>
              <FaHeart /> Wishlist {wishlist.length > 0 && <span className="bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">{wishlist.length}</span>}
            </button>
            {/* <button onClick={() => setActiveTab('profile')} className={`font-medium transition ${activeTab === 'profile' ? 'text-green-600 border-b-2 border-green-600 pb-1' : 'text-gray-600 hover:text-green-600'}`}>Profile</button> */}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      {/* <div className="bg-gradient-to-r from-green-700 to-green-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl font-bold mb-2 flex items-center gap-2"><FaFish /> Premium Live Fish Collection</h1>
          <p className="text-white/80">Discover growing fishes, pond fishes, and golden fishes for your aquarium</p>
        </div>
      </div> */}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Filters Bar */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm">
          <div className="flex flex-wrap gap-4 items-center justify-between">
            <div className="flex gap-2 flex-wrap">
              {categories.map(cat => (
                <button key={cat} onClick={() => setSelectedCategory(cat)} className={`px-4 py-2 rounded-full text-sm ${selectedCategory === cat ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>{cat}</button>
              ))}
            </div>
            <div className="flex gap-2">
              {DesktopSearchBar()}
              <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500">
                <option value="default">Sort by</option>
                <option value="priceLow">Price: Low to High</option>
                <option value="priceHigh">Price: High to Low</option>
                <option value="rating">Top Rated</option>
              </select>
            </div>
          </div>
        </div>

        {/* Stats */}
        <p className="text-gray-500 mb-4">{sortedProducts.length} fish found</p>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {sortedProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>

      {/* WhatsApp Button */}
      <a href="https://wa.me/918072621187?text=Hi%2C%20I'm%20interested%20in%20your%20fish" className="fixed bottom-8 right-8 bg-green-500 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition z-40" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp className="text-2xl" />
      </a>
    </div>
  );

  // Wishlist View (for both mobile and desktop)
  const WishlistView = () => {
    const wishlistProducts = fishProducts.filter(p => wishlist.includes(p.id));
    return (
      <div className="max-w-7xl mx-auto px-4 py-6 pb-24 md:pb-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2"><FaHeart className="text-red-500" /> My Wishlist</h2>
        {wishlistProducts.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 bg-white rounded-2xl">
            <FaRegHeart className="text-7xl text-gray-300 mb-4" />
            <p className="text-gray-500 mb-5">No items in wishlist</p>
            <button onClick={() => setActiveTab('home')} className="bg-green-600 text-white px-6 py-2 rounded-full">Browse Fish</button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {wishlistProducts.map(product => <ProductCard key={product.id} product={product} />)}
          </div>
        )}
      </div>
    );
  };

  // Profile View
  const ProfileView = () => (
    <div className="max-w-4xl mx-auto px-4 py-6 pb-24 md:pb-6">
      <div className="bg-gradient-to-r from-green-700 to-green-800 rounded-2xl p-8 text-center mb-8">
        <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4"><FaUser className="text-5xl text-white" /></div>
        <h3 className="text-2xl font-bold text-white">Fish Enthusiast</h3>
        <p className="text-white/80">+91 98765 43210</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl p-5 text-center shadow-sm"><FaFish className="text-3xl text-green-600 mx-auto mb-2" /><span className="text-2xl font-bold text-gray-800">{fishProducts.length}</span><p className="text-gray-500 text-sm">Total Fish</p></div>
        <div className="bg-white rounded-xl p-5 text-center shadow-sm"><FaHeart className="text-3xl text-red-500 mx-auto mb-2" /><span className="text-2xl font-bold text-gray-800">{wishlist.length}</span><p className="text-gray-500 text-sm">Wishlist</p></div>
        <div className="bg-white rounded-xl p-5 text-center shadow-sm"><FaStar className="text-3xl text-yellow-500 mx-auto mb-2" /><span className="text-2xl font-bold text-gray-800">4.8</span><p className="text-gray-500 text-sm">Rating</p></div>
      </div>
      <div className="bg-white rounded-xl overflow-hidden shadow-sm">
        {[{ icon: FaBox, label: 'My Orders' }, { icon: FaMapMarkerAlt, label: 'Delivery Address' }, { icon: FaCreditCard, label: 'Payment Methods' }, { icon: FaQuestionCircle, label: 'Help & Support' }, { icon: FaCog, label: 'Settings' }].map((item, index) => (
          <div key={index} className="px-6 py-4 border-b border-gray-100 last:border-0 text-gray-700 hover:bg-gray-50 transition cursor-pointer flex items-center gap-3"><item.icon className="text-green-600" /><span>{item.label}</span><FaArrowRight className="ml-auto text-gray-400" /></div>
        ))}
      </div>
    </div>
  );

  // Render based on active tab and device
  if (activeTab === 'wishlist') return isMobile ? <div className="max-w-md mx-auto bg-gray-50 min-h-screen">{WishlistView()}</div> : WishlistView();
  if (activeTab === 'profile') return isMobile ? <div className="max-w-md mx-auto bg-gray-50 min-h-screen">{ProfileView()}</div> : ProfileView();
  
  return isMobile ? MobileView() : DesktopView();
};

export default FishPage;
